import { createEnum } from './enum.js'

export default createEnum('None', 'Right upper lid', 'Left upper lid', 'Both upper lids');
